export const VoE = (obj, key) => obj && obj[key] ? obj[key] : '';
export default VoE;



// WEBPACK FOOTER //
// ./app/shared/lib/ValidOrEmpty/index.js